import { render } from "./GeneralUserInfoTab.vue?vue&type=template&id=68d4117b&scoped=true"
import script from "./GeneralUserInfoTab.vue?vue&type=script&lang=js"
export * from "./GeneralUserInfoTab.vue?vue&type=script&lang=js"

import "./GeneralUserInfoTab.vue?vue&type=style&index=0&id=68d4117b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d4117b"]])

export default __exports__